import React, { useEffect, useState } from 'react';

// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-redeclare
import { Select } from '@sede-enterprise/shell-ds-react-framework';
import { DropDownListStyled } from './DropDownList.styled';


export interface IDictionary {
  key: string;
  value: string;
}

export interface IDropDownListProps {
  content: IDictionary[];
  placeholder?: string;
  disabled?: boolean;
  allowClear?: boolean;
  onSelect: any;
  value?: string;
  width?: string;
}

const DropDownList: React.FC<IDropDownListProps> = (props) => {

  const [books,setBooks] = useState<{label:string,value:string}[]>([]);
  const [bookValue, setBookValue] = useState<string | undefined>(undefined);

  useEffect(()=>{
    const mappedBooks = props.content.map((book) => ({
      value: book.key.toString(),
      label: book.value,
    }));
    
    const selectedBook = props.content.find((book) => book.key === props.value);

    setBooks(mappedBooks);
    setBookValue(selectedBook?.value || undefined);
  },[props.content,props.value])

  return (
    <DropDownListStyled style={{ width: `${props.width}`}} id='dropDownListStyleAdder' data-testid="DropDownList">
      <Select
        className='select-container'
        options={books}
        value={bookValue}
        onChange={props.onSelect}
        placeholder={props.placeholder}
        disabled={props.disabled}
        allowClear={props.allowClear}
      />
    </DropDownListStyled>
  );
};

export default DropDownList;
